'use client'

import { useState } from 'react'

/**
 * Compact square thumbnail for the /instructions hub rows.
 *
 * Shows the product image when it loads; if the file is missing (or fails to
 * load) it falls back to a monospace product-code chip — so the hub never shows
 * a broken-image icon and looks clean before product photos are added.
 */
export function ProductThumb({ image, code }: { image?: string; code: string }) {
  const [failed, setFailed] = useState(false)

  if (image && !failed) {
    // eslint-disable-next-line @next/next/no-img-element
    return (
      <img
        src={image}
        alt=""
        onError={() => setFailed(true)}
        style={{
          width: 52,
          height: 52,
          borderRadius: 12,
          objectFit: 'cover',
          flexShrink: 0,
          border: '1px solid var(--pub-border)',
          background: 'var(--pub-surface-3)',
        }}
      />
    )
  }

  return (
    <div
      className="flex items-center justify-center flex-shrink-0"
      style={{
        width: 52,
        height: 52,
        borderRadius: 12,
        background: 'var(--pub-surface-3)',
        border: '1px solid var(--pub-border)',
      }}
    >
      <span
        style={{
          fontFamily: 'var(--font-pub-mono)',
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '0.02em',
          color: 'var(--pub-text-secondary)',
          textAlign: 'center',
          lineHeight: 1.15,
          padding: '0 4px',
        }}
      >
        {code}
      </span>
    </div>
  )
}
